exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-borderbottom[data-v-c2f670cc]{margin-bottom:15px!important;padding-bottom:8px;border-bottom:1px solid #e1e1e1}.positon-group[data-v-c2f670cc]{display:grid!important;grid-template-columns:1fr;gap:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-c2f670cc","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/formBuilder/formConfig.vue
// module id = 7TmW
// module chunks = 0